export default {
      id: "zirve-oran-new-banner-badge-usage",
      viewBox: "0 0 104 21",
      url: "/" + "images/icons.3.109.2.svg#zirve-oran-new-banner-badge-usage",
      toString: function () {
        return this.url;
      }
    }